export default "__VITE_ASSET__CZWv7AlE__"